import React, { useState, useEffect } from "react";
import {toast } from "react-toastify";
import axiosInstance from '../../axiosInstance'; 

const CategoryPopup = ({ closePopup, editData, triggerReload }) => {
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [isEditing, setIsEditing] = useState(false);


  useEffect(() => {
    if (editData?.id) {
      const fetchData = async () => {
        try {
          const response = await axiosInstance.get(`/costsolution/category/get/${editData.id}`);
          const data = response.data;
          setCode(data.category.code || "");
          setName(data.category.name || "");
          setIsEditing(true);
        } catch (error) {
          console.error("Error fetching data:", error);
           toast.error("Error fetching details");
        }
      };
      fetchData();
    }
  }, [editData?.id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const postData = { code, name };

    try {
      const url = isEditing
        ? `/costsolution/category/${editData?.id}`
        : "/costsolution/category";

      const method = isEditing ? "put" : "post";
      const response = await axiosInstance[method](url, postData);

      if (response.status === 200 || response.status === 201) {
        toast.success(isEditing ? "Data updated successfully!" : "Data saved successfully!");
        setCode("");
        setName("");
        closePopup();
        triggerReload(); 
      } else {
         toast.error("Error: " + (response.data.message || "Failed to process request"));
      }
    } catch (error) {
      console.error("Error:", error);
       toast.error("Something went wrong!");
    }
  };

  const handleClear = () => {
    setCode("");
    setName("");
  };

  return (

    <div className="scope-creation-popup-overlay">
      <div className="scope-creation-popup-container">
        <div className="scope-creation-popup-header">
          <h2>{isEditing ? "Edit Category" : "Create Category"}</h2>
          <button className="close-button" onClick={closePopup}>
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit}>
        <div className="scope-creation-popup-body">
          <div className="scope-creation-form-group">
            <label htmlFor="code" className="labels">Code</label>
            <input
              type="text"
              id="code"
              name="code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
              style={{ margin: "0px" }}
            />
          </div>

          <div className="scope-creation-form-group">
            <label htmlFor="name" className="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              style={{ margin: "0px" }}
            />
          </div>
           </div>
          <div className="scope-creation-popup-footer">
            <button type="button" className="scope-clear-button" onClick={handleClear}>
              Clear
            </button>
            <button type="submit" className="scope-submit-button">
              {isEditing ? "Update" : "Submit"}
            </button>
          </div>
          </form>
      </div>
    </div>

  );
};

export default CategoryPopup;
